import { Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ErrorMessagesComponent } from '../../error-messages/error-messages.component';
import { ReadToWriteBase } from '../read-to-write-base.class';

@Component({
  imports: [ErrorMessagesComponent, FormsModule, MatError, MatFormField, MatInput, MatLabel, ReactiveFormsModule],
  selector: 'app-read-to-write-input',
  styleUrl: './read-to-write-input.component.scss',
  templateUrl: './read-to-write-input.component.html',
})
export class ReadToWriteInputComponent extends ReadToWriteBase<string | null> {
  public readonly inputType = input('text');
}
